/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconErrorRed = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--errorred',
    className,
  )

  return (
    <IconBase className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"{...rest}><g fill="none" fillRule="evenodd" opacity=".9"><path className="path1" d="M-2-2h24v24H-2z"/><path className="path2" fill="#E76C5E" fillRule="nonzero" d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9v-2h2v2zm0-4H9V5h2v6z"/></g></IconBase>
  )
}

IconErrorRed.propTypes = {
  className: PropTypes.string,
}

export default IconErrorRed
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconErrorRed.js